import { render } from "./EmptyListMessage.vue?vue&type=template&id=2b40df10"
import script from "./EmptyListMessage.vue?vue&type=script&lang=js"
export * from "./EmptyListMessage.vue?vue&type=script&lang=js"
script.render = render

export default script